/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Enum from 'astro/enum/route';

import BuildingAttack from 'astro/config/behavior/building.attack';
import BuildingCreate from 'astro/config/behavior/building.create';
import BuildingUpgrade from 'astro/config/behavior/building.upgrade';

import UnitAttack from 'astro/config/behavior/unit.attack';
import UnitCreate from 'astro/config/behavior/unit.create';

import Welcome from 'astro/config/behavior/welcome'
import Manual from 'astro/config/behavior/manual'


let Config = {};


Config[Enum.BuildingAttack]      = BuildingAttack;
Config[Enum.BuildingCreateList]  = BuildingCreate;
Config[Enum.BuildingCreateType]  = BuildingCreate;
Config[Enum.BuildingUpgrade]     = BuildingUpgrade;

Config[Enum.UnitAttack]          = UnitAttack;
Config[Enum.UnitCreateList]      = UnitCreate;
Config[Enum.UnitCreateType]      = UnitCreate;

Config[Enum.WelcomeManual]       = Manual;
Config[Enum.WelcomeLogin]        = Manual;

Config[Enum.WelcomeAbout]        = Welcome;
Config[Enum.WelcomeTerms]        = Welcome;
Config[Enum.WelcomePrivacy]      = Welcome;


export default Config;
